import { Newspaper } from "lucide-react"
import InfiniteScrollText from "../common/InfiniteScrollText"

export const Section2 = ()=>{
  return <section className=" mt-3 px-2">
    <div className=" flex gap-3">
     <div>
      <img width={25} src="https://9wicket.pro/images/extra-icon/announcement.png" alt="" />
     </div>
     <div>
    <InfiniteScrollText text="WELCOME TO 9WICKET FAMILY ! ENJOY BETTING IN MATCH ODDS, ﻿FANCY & LIVE CASIN"/>
     </div>
    </div>
  </section>
}